export enum EmploymentType {
  Employee = 1,
  Retired,
  JobSeeker,
  Business,
  Other,
}
